/* eslint-disable multiline-ternary, indent */
import React, { useState } from 'react'
import { Stepper } from './components'
import LpqPage from './components/page'
import useEventData from './hooks/useEventData'
import { WelcomeContent, WelcomeFooter, Step1Content } from './pages'
import Step2Content from './pages/step2-content'
import Step3Content from './pages/step3-content'

const LpQuestionnaire = ({ onClose, onFinish }) => {
  const [data, setData] = useState({})
  const [step, setStep] = useState()

  const convert = useEventData()

  const maxSteps = 3

  const handleNext = () =>
    setStep(current => (current === undefined ? 0 : current + 1))

  const handleBack = () =>
    setStep(current => (current === undefined ? 0 : current - 1))

  const handleLeave = from => {
    onClose(from)
  }

  const handleFinish = () => {
    onFinish(convert(data))
  }

  const handleChange = ({ data, value }) => {
    setData(current => ({ ...current, [data]: value }))
  }

  const renderStep = () => {
    return step === undefined ? (
      <LpqPage
        title='Welcome to Mindtools'
        content={<WelcomeContent onStart={handleNext} onLeave={handleLeave} />}
        footer={<WelcomeFooter />}
        onClose={handleLeave}
      />
    ) : step === 0 ? (
      <LpqPage
        title='Customize your learning experience'
        content={<Step1Content onChange={handleChange} data={data} />}
        footer={
          <Stepper
            activeStep={step}
            maxSteps={maxSteps}
            onNext={handleNext}
            onLeave={handleLeave}
            data-test='lpq-step1-stepper'
          />
        }
        onClose={handleLeave}
      />
    ) : step === 1 ? (
      <LpqPage
        title='Customize your learning experience'
        content={<Step2Content onChange={handleChange} data={data} />}
        footer={
          <Stepper
            activeStep={step}
            maxSteps={maxSteps}
            onBack={handleBack}
            onNext={handleNext}
            onLeave={handleLeave}
            data-test='lpq-step2-stepper'
          />
        }
        onClose={handleLeave}
      />
    ) : step === 2 ? (
      <LpqPage
        title='Customize your learning experience'
        content={<Step3Content onChange={handleChange} data={data} />}
        footer={
          <Stepper
            activeStep={step}
            maxSteps={maxSteps}
            onBack={handleBack}
            onFinish={handleFinish}
            onLeave={handleLeave}
            data-test='lpq-step3-stepper'
          />
        }
        onClose={handleLeave}
      />
    ) : null
  }

  return renderStep()
}

export default LpQuestionnaire
